module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "chapter-title1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("EXAMPLES")]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01#ex1.1"
    }
  }, [_vm._v("Example 1.1. Excerpt from Sigismondo d'India, "), _c('em', [_vm._v("Lamento di Didone")]), _vm._v(" (1623)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01#ex1.2"
    }
  }, [_vm._v("Example 1.2. “Tremoletto” from Martin Fuhrmann, "), _c('em', [_vm._v("Musicalischer Trichter")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/chap02#ex2.1"
    }
  }, [_vm._v("Example 2.1. Sigismondo d'India, "), _c('em', [_vm._v("O dolcezz'amarissime d'amore")]), _vm._v(" (1609)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/chap02#ex2.2"
    }
  }, [_vm._v("Example 2.2. Tosi's trills (as realized by Agricola): (a) "), _c('em', [_vm._v("trillo maggiore;")]), _vm._v(" (b) "), _c('em', [_vm._v("trillo minore;")]), _vm._v(" (c) "), _c('em', [_vm._v("mezzotrillo;")]), _vm._v(" (d) "), _c('em', [_vm._v("trillo raddoppiato;")]), _vm._v(" (e) "), _c('em', [_vm._v("trillo raddoppiato;")]), _vm._v(" (f) "), _c('em', [_vm._v("trillo mordente")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/chap02#ex2.3"
    }
  }, [_vm._v("Example 2.3. Chain of trills (Johann Friedrich Agricola)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08#ex8.1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 8.1a. Petronio Franceschini: Sonata in D, mvt. 2")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08#ex8.1b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 8.1b. Maurizio Cazzati: Sonata 5, "), _c('em', [_vm._v("La Caprara")]), _vm._v(", Op. 35, no. 10, mvt. 1")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08#ex8.1c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 8.1c. Cazzati: "), _c('em', [_vm._v("La Caprara")]), _vm._v(", mvt. 4")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08#ex8.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 8.2. Petronio Franceschini: Sonata in D: (a) mvt. 1; (b) mvt. 3")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08#ex8.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 8.3. Girolamo Fantini: Sonata No. 5, "), _c('em', [_vm._v("detta dell'Adimari")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#ex9.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 9.1. Marin Mersenne, "), _c('em', [_vm._v("Harmonie universelle")]), _vm._v(", drum rhythms")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#ex9.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 9.2. "), _c('em', [_vm._v("Wirbel")]), _vm._v(" and "), _c('em', [_vm._v("doppel-wirbel")]), _vm._v(" (from Johann Ernst Altenburg, "), _c('em', [_vm._v("Versuch einer Anleitung)")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#ex9.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 9.3. "), _c('em', [_vm._v("Final-cadence")]), _vm._v(" (from Speer, "), _c('em', [_vm._v("Musikalisches Kleeblatt")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#ex9.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 9.4. (a) Cross-stickings; (b) double cross-stickings; (c) eight-note or simple beatings")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#ex9.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 9.5. (a) Simple tonguings as notated and realized; (b) double tonguings as notated and realized; (c) extended double tonguings as notated and realized; (d) carrying tonguings as notated and realized")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#ex11.1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Examples 11.1a–b. Georg Muffat bowing examples")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#ex11.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 11.2. Gasparo Zannetti's "), _c('em', [_vm._v("La Nimfardina di Santino")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#ex11.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 11.3. Seventeenth-century bowing examples")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#ex14.1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 14.1a. Johann Jakob Froberger, Toccata 1 in A minor, mm. 1–3")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#ex14.1b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 14.1b. Louis Couperin, "), _c('em', [_vm._v("Prélude à l'imitation de Mr. Froberger")]), _vm._v(" (excerpt)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.1. The correct sequence for playing arpeggios")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.2. Added dissonance to simplify left-hand fingering")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.3a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3a. Fourteen-course archlute")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.3b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3b. Fourteen-course theorbo")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.3c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3c. Ten-course lute in Renaissance tuning ("), _c('em', [_vm._v("vieux ton")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.3d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3d. Eleven-course lute in D-minor tuning")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.3e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3e. "), _c('em', [_vm._v("À cordes avalées")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.3f",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3f. French flat tuning")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.3g",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3g. French sharp tuning")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.3h",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3h. Gallichon")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chap15#ex15.3i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3i. Angélique")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.3j",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3j. Baroque guitar tunings")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.3k",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3k. Mandore")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#ex15.3l",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 15.3l. Mandolino")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.1. Aurelio Virgiliano: "), _c('em', [_vm._v("Il dolcimelo")]), _vm._v(" (ca. 1590)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.2. Aurelio Virgiliano: "), _c('em', [_vm._v("Il dolcimelo")]), _vm._v(" (ca. 1590)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.3. Aurelio Virgiliano: "), _c('em', [_vm._v("Il dolcimelo")]), _vm._v(" (ca. 1590)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.4. Giulio Caccini: "), _c('em', [_vm._v("Le nuove musiche")]), _vm._v(" (1602)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.5. Antonio Brunelli: "), _c('em', [_vm._v("Varii esercitii…")]), _vm._v(" (1614)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.6. Giovanni Bovicelli: "), _c('em', [_vm._v("Regole, passaggi di musica")]), _vm._v(" (1594)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.7. Basic form of the "), _c('em', [_vm._v("groppo")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.8. Giovanni Bovicelli: "), _c('em', [_vm._v("Regole, passaggi di musica")]), _vm._v(" (1594)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.9. Giovanni Bovicelli: "), _c('em', [_vm._v("Regole, passaggi di musica")]), _vm._v(" (1594)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.10. Lodovico Zacconi: "), _c('em', [_vm._v("Prattica di musica")]), _vm._v(" (1592)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.11. Giovanni Luca Conforto: "), _c('em', [_vm._v("Breve et facile maniera")]), _vm._v(" (1593)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.12. Giovanni Bovicelli: "), _c('em', [_vm._v("Regole, passaggi di musica")]), _vm._v(" (1594)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.13. Claudio Monteverdi: "), _c('em', [_vm._v("Audi cœlum")]), _vm._v(" from 1610 Vespers")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.14. Lodovico Zacconi: "), _c('em', [_vm._v("Prattica di musica")]), _vm._v(" (1592)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.15. Lodovico Zacconi: "), _c('em', [_vm._v("Prattica di musica")]), _vm._v(" (1592)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.16. Francesco Rognoni: "), _c('em', [_vm._v("Selva de varii passaggi")]), _vm._v(" (1620)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.17. Lodovico Zacconi: "), _c('em', [_vm._v("Prattica di musica")]), _vm._v(" (1592)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.18. Lodovico Zacconi: "), _c('em', [_vm._v("Prattica di musica")]), _vm._v(" (1592)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.19. Emilio de’ Cavalieri: “"), _c('em', [_vm._v("Zimbelo")]), _vm._v("” as found in "), _c('em', [_vm._v("Rappresentatione di anima, e di corpo")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.20. Claudio Monteverdi: “"), _c('em', [_vm._v("ribattuta di gola")]), _vm._v("” as found in "), _c('em', [_vm._v("Duo seraphim")]), _vm._v(" from 1610 Vespers")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.21. Giulio Caccini: “"), _c('em', [_vm._v("esclamatione")]), _vm._v("” as found in "), _c('em', [_vm._v("Le nuove musiche")]), _vm._v(" (1602)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.22. Francesco Rognoni: “"), _c('em', [_vm._v("tremolo")]), _vm._v("” as found in "), _c('em', [_vm._v("Selva de varii passaggi")]), _vm._v(" (1620)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.23. Francesco Rognoni: “"), _c('em', [_vm._v("tremolo")]), _vm._v("” as found in "), _c('em', [_vm._v("Selva de varii passaggi")]), _vm._v(" (1620)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.24. Giovanni Luca Conforto: “"), _c('em', [_vm._v("trillo")]), _vm._v("” as found in "), _c('em', [_vm._v("Breve et facile maniera")]), _vm._v(" (1593)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.25. Girolamo Dalla Casa: “"), _c('em', [_vm._v("tremolo groppizato")]), _vm._v("” as found in "), _c('em', [_vm._v("Il vero modo di diminuir")]), _vm._v(" (1584)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ex16.26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 16.26. Giulio Caccini: “"), _c('em', [_vm._v("trilli")]), _vm._v("” as found in "), _c('em', [_vm._v("Le nuove musiche")]), _vm._v(" (1602)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#ex17.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 17.1. Conventional patterns for realizing a falling fifth at a cadence")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#ex17.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 17.2. Dieterich Buxtehude, "), _c('em', [_vm._v("Fürchtet dich nicht")]), _vm._v(", BuxWV 30, Sonata, mm. 1–11")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#ex17.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 17.3. Angelo Notari, "), _c('em', [_vm._v("A la caccia")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#ex17.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 17.4. Bellerofonte Castaldi, "), _c('em', [_vm._v("Capricci a due stromenti cioè tiorba e tiobina")]), _vm._v(" (1622)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#ex17.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 17.5. Sample arpeggio patterns for "), _c('em', [_vm._v("continuo")]), _vm._v(" realization")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#ex17.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 17.6. Sample cadential patterns for "), _c('em', [_vm._v("continuo")]), _vm._v(" realization")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#ex17.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 17.7. "), _c('em', [_vm._v("Continuo")]), _vm._v(" realization of an aria, ca. 1700, from Anonymous, "), _c('em', [_vm._v("Regole…d'accompagnare")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#ex17.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 17.8. Henry Lawes, "), _c('em', [_vm._v("Sweet Stay Awhile")]), _vm._v(" (figures editorial)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#ex17.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 17.9. Sample realizations for cadential suspensions")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#ex17.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 17.10. John Blow, sample realizations for cadential suspensions")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chap17#ex17.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 17.11. Francesco Durante, solo "), _c('em', [_vm._v("partimento")]), _vm._v(" exercise (from "), _c('em', [_vm._v("Partimenti, ossia intero studio di numerate")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#ex18.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example 18.1. Mensural notation")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("FIGURES")]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01#ch1_f001"
    }
  }, [_vm._v("Figure 1.1. Linkage of selected seventeenth-century singing treatises")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap06#ch6_f001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6.1. Fingering chart for cornett in "), _c('em', [_vm._v("a")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07#ch7_f001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.1. Michael Praetorius, "), _c('em', [_vm._v("Syntagma Musicum II, Theatrum Instrumentorum")]), _vm._v(" (1620), plate 8")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07#ch7_f002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.2. Michael Praetorius, "), _c('em', [_vm._v("Syntagma Musicum II, De Organographia")]), _vm._v(" (1619)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07#ch7_f003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.3. Michael Praetorius, "), _c('em', [_vm._v("Syntagma Musicum II, Theatrum Instrumentorum")]), _vm._v(", plate 6 (detail)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07#ch7_f004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.4. Marin Mersenne, "), _c('em', [_vm._v("Harmonie universelle")]), _vm._v(", vol. 3")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07#ch7_f005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.5. Lodovico Carracci, "), _c('em', [_vm._v("Il paradiso")]), _vm._v(" (ca. 1616). Bologna, Church of San Paolo (detail) 122")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07#ch7_f006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7.6. Hans Burgkmair and others, "), _c('em', [_vm._v("Der Triumphzug Maximilians I")]), _vm._v(" (1526), plate 78 (detail)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08#ch8_f001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8.1. Two illustrations of a twice-folded, elongated trumpet, as depicted in Marin Mersenne, "), _c('em', [_vm._v("Harmonie universelle")]), _vm._v(" (1636)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#ch9_f001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 9.1. Michael Praetorius, "), _c('em', [_vm._v("Syntagma Musicum II, Theatrum Instrumentorum")]), _vm._v(", plate 23; field timpani (1); field drums (2); Swiss fipple flute (3); anvil (4)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#ch9_f002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 9.2. Michael Praetorius, "), _c('em', [_vm._v("Syntagma Musicum II, Theatrum Instrumentorum")]), _vm._v(", plate 29: satyr pipes (1 and 2); American horn or trumpet (3); a ring, played by the Americans in the way we [Germans] play the triangle (4); American shawm (5); cymbals, upon which the Americans play in the way we play bells (6); a ring with jingles, which they throw into the air and catch again (7); American drums (8 and 9)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#ch10_f001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 10.1. From Thoinot Arbeau's "), _c('em', [_vm._v("Orchésographie")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#ch10_f002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 10.2. Early seventeenth-century violin band")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#ch11_f001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 11.1. Violin consort: detail from the title page of Andreas Hammerschmidt's "), _c('em', [_vm._v("Missæ")])])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#ch12_f001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 12.1. Violas da gamba from Praetorius's "), _c('em', [_vm._v("Syntagma Musicum II, Theatrum Instrumentorum")]), _vm._v(", plate 20")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ch16_f001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 16.1. Giovanni Luca Conforto: "), _c('em', [_vm._v("Breve et facile maniera")]), _vm._v(" (1593)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#ch16_f002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 16.2. Aurelio Virgiliano: "), _c('em', [_vm._v("Il dolcimelo")]), _vm._v(" (ca. 1590)")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#ch21_f001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 21.1. Festivities for the aborted state visit to Rome of Prince Alexander Charles of Poland, February 25, 1634")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap21#ch21_f002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 21.2. Ballet of Twelve Nations. Festivities in Stuttgart surrounding baptism of Prince Friedrich von Württemberg, March 10–17, 1616")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap21#ch21_f003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 21.3. Torch dance; part of celebrations surrounding coronation of Matthias I as Holy Roman Emperor, Frankfurt am Main, June 14, 1612")])]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("TABLES")]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07#ch7_t001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 7.1. Dimensions (in millimeters) of extant seventeenth-century trombones")])]), _vm._v(" "), _c('p', {
    staticClass: "illustration"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07#ch7_t002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table 7.2. Dimensions (in millimeters) of early trombone mouthpieces")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-075fdb0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/illustrations.vue
// module id = 72
// module chunks = 0